import {BaseEvent} from "../BaseEvent";
import {GatewayWorkflowStatus} from "../../models/notification/GatewayWorkflowStatus";


export class GatewayWorkflowChangedNtf extends BaseEvent {
  public static NAME = 'gatewayWorkflowChanged';
  public value: GatewayWorkflowStatus;

  constructor(workflow: GatewayWorkflowStatus) {
    super(GatewayWorkflowChangedNtf.NAME);

    this.value = workflow;
  }
}
